<template>
	<DjBox class="pt-5 md:pt-8 px-5 md:px-10 pb-5 md:pb-10">
		<h3 class="text-lg md:text-xl font-medium mb-4">{{ title }}</h3>
		<div class="flex flex-wrap justify-center gap-5">
			<div
				class="flex flex-col items-center"
				:class="data.length == 1 ? '' : 'max-w-[45%]'"
				v-for="(item, index) in data"
				:key="index"
			>
				<BaseCloudImage
					:class="[borderless ? '' : 'border border-dj-gray-light', 'rounded-normal overflow-hidden']"
					custom-class="max-w-[120px] md:max-w-[160px]"
					:public-id="item.url"
					:alt="item.label || ''"
					:postfix="item.postfix ?? '.jpg'"
					:transformation="[{ width: 160, height: 160, crop: 'scale' }]"
				/>
				<span
					v-if="item.label != ''"
					class="break-words"
					:class="[
						boldLabel ? 'font-medium' : '',
						'text-sm md:text-base mt-[10px] max-w-[120px] md:max-w-[160px] text-center',
					]"
				>
					{{ item.label }}
				</span>
			</div>
		</div>
	</DjBox>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import DjBox from "~/ui-kit/components/box/DjBox.vue";
import BaseCloudImage from "../BaseCloudImage.vue";

type DataType = {
	url: string;
	label: string;
};

export default defineComponent({
	name: "DjBoxPhotosWithLabel",
	components: {
		BaseCloudImage,
		DjBox,
	},
	props: {
		title: {
			type: String,
			default: "Box title",
		},
		boldLabel: {
			type: Boolean,
			default: false,
		},
		data: {
			type: Array as PropType<DataType[]>,
			required: true,
		},
		borderless: {
			type: Boolean,
			default: false,
		},
	},
});
</script>
